import { StatusBadge, Tooltip, TooltipContent, TooltipPortal, TooltipTrigger } from '@atrvd/saas-ui'
import type { BankConnectionRow } from '@/lib/db-tenant'
import { presentConnectionStatus } from './ledgerSyncConnectedBanks.utils'

/** Props for {@link ConnectionStatusBadge}. */
interface ConnectionStatusBadgeProps {
  connection: Pick<BankConnectionRow, 'status' | 'accounts_count' | 'last_error'>
}

/**
 * A connection's status badge. For an unhealthy connection the badge is a
 * focusable tooltip trigger carrying the reason (the vendor's raw
 * `last_error` when present) and the Reconnect hint.
 */
export function ConnectionStatusBadge({ connection }: ConnectionStatusBadgeProps) {
  const { badge, label, attention } = presentConnectionStatus(connection)
  const statusBadge = <StatusBadge status={badge} showIcon label={label} />
  if (!attention) return statusBadge
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        {/* Focusable so keyboard users can open the explanation too. */}
        <span tabIndex={0} className="inline-flex cursor-help">
          {statusBadge}
        </span>
      </TooltipTrigger>
      <TooltipPortal>
        <TooltipContent className="max-w-xs">{attention}</TooltipContent>
      </TooltipPortal>
    </Tooltip>
  )
}
